"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processPath = exports.createUploadRequest = exports.addToRequest = exports.addFolderToRequest = void 0;
var _constants = require("util/constants");
var _session = require("@/utils/session");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var addToRequest = exports.addToRequest = function addToRequest(attributes, files, selectedFolder) {
  var _iterator = _createForOfIteratorHelper(files),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (item.isFolder === _constants.TYPE_FOLDER) {
        _addFolderToRequest(attributes, item, selectedFolder);
      } else {
        var _item$metadata;
        attributes[item.file.name] = {
          category: item.category,
          metadata: (_item$metadata = item.metadata) !== null && _item$metadata !== void 0 ? _item$metadata : "",
          path: selectedFolder === "" ? "" : selectedFolder + "/",
          fileName: item.file.name
        };
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var _addFolderToRequest = exports.addFolderToRequest = function addFolderToRequest(attributes, file, selectedFolder) {
  if (!file.files) return;
  var _iterator2 = _createForOfIteratorHelper(file.files),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var f = _step2.value;
      if (f.isFolder === _constants.TYPE_FOLDER) {
        _addFolderToRequest(attributes, f, selectedFolder);
      } else {
        var _f$metadata, _f$path;
        var path = selectedFolder === "" ? "" : selectedFolder + "/";
        attributes[f.file.name] = {
          category: f.category,
          metadata: (_f$metadata = f.metadata) !== null && _f$metadata !== void 0 ? _f$metadata : "",
          path: path + ((_f$path = f.path) !== null && _f$path !== void 0 ? _f$path : ""),
          fileName: f.file.name
        };
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};
var processPath = exports.processPath = function processPath(existingPath) {
  if (existingPath === "") {
    return "";
  }
  if (existingPath.endsWith("/")) {
    return existingPath;
  }
  return existingPath + "/";
};
var createUploadRequest = exports.createUploadRequest = function createUploadRequest(files) {
  var sendData = new FormData();
  var attributes = {};
  var _getUserInfo = (0, _session.getUserInfo)(),
    userName = _getUserInfo.nameUser,
    userId = _getUserInfo.userId;
  var _iterator3 = _createForOfIteratorHelper(files),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var item = _step3.value;
      sendData.append("files", item.file);
      attributes[item.file.name] = {
        category: item.fileCategory,
        metadata: item.metadata,
        path: item.path,
        uuid: item.uuid
      };
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  sendData.append("blob_metadata_dict", JSON.stringify({
    attributes: attributes,
    upload_by: userName,
    user_uuid: userId,
    source: _constants.KB_SOURCE
  }));
  return sendData;
};